import React from "react";
import "./roadmap.css";
import RoadmapItem from "../../components/RoadmapItem/RoadmapItem";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import HambMenu from "../../components/hamburger-menu/HambMenu";
import { useState } from "react";
import { useSelector } from "react-redux";
import { selectUserLanguage } from "../../features/user/userSlice";
import useLanguage from "../../hooks/useLanguage";

const Roadmap = () => {
  const currentLanguage = useSelector(selectUserLanguage) || "es";

  // Get texts based on current language
  const texts = useLanguage(currentLanguage, "views.landingPage");

  const [showMenu, setShowMenu] = useState(false);

  return (
    <>
      <Header
        texts={texts}
        showMenu={showMenu}
        setShowMenu={setShowMenu}
        inLandingPage={false}
      />
      {!showMenu ? (
        <div className="roadmap-container-background">
          <div className="roadmap-container">
            <div className="roadmap-header">
              <h2>De la Idea a la Implementación</h2>
              <p>
                Conoce los pasos que hemos dado para construir AMVI: desde
                nuestros primeros logros en concursos hasta el desarrollo y
                lanzamiento de nuestra app. Cada etapa ha sido clave para llegar
                a donde estamos hoy.
              </p>
            </div>
            <div className="roadmap-content">
              <span>2023</span>
              <RoadmapItem
                label="Mayo"
                description="Ganadores del XIGNUX Challenge 2023"
                position="right"
                leftPosition="66%"
              />
              <RoadmapItem
                label="Agosto"
                description="Ingreso al Círculo Emprendedor del Tec de Monterrey"
                position="left"
                leftPosition="32.2%"
              />
              <RoadmapItem
                label="Octubre"
                description="Inicio del análisis con programador freelance"
                position="right"
                leftPosition="67.5%"
              />
              <RoadmapItem
                label=""
                description="Desarrollo de la primera identidad visual y nombramiento 'Pool-e' con agencia de mercadotecnia (nombre no disponible legalemente)"
                position="left"
                leftPosition="32.2%"
              />
              <span>2024</span>
              <RoadmapItem
                label="Julio"
                description="GUUD Consulting realiza el analisis completo programación del sistema, apoya en mercadotecnia y desarrolla la nueva marca 'AMVI'"
                position="right"
                leftPosition="68%"
              />
              <RoadmapItem
                label="Agosto"
                description="Se inicio el diseño prototipo no funcional en Figma"
                position="left"
                leftPosition="32.2%"
              />
              <RoadmapItem
                label=""
                description="Desarrollo y aprobación de la identidad visual"
                position="right"
                leftPosition="68%"
              />
              <RoadmapItem
                label="Septiembre"
                description="Se une una practicante de Ingenieria en desarrollo sustentable del ITESM"
                position="left"
                leftPosition="34.6%"
              />
              <RoadmapItem
                label=""
                description="Desarrollo y codificación de solución"
                position="right"
                leftPosition="65.2%"
              />
              <RoadmapItem
                label=""
                description="El proyecto evoluciona y adopta su nuevo nombre alineado con su mision"
                position="left"
                leftPosition="32.2%"
              />
              <RoadmapItem
                label="Octubre"
                description="AMVI se registra legalmente como marca en México"
                position="right"
                leftPosition="67.5%"
              />
              <RoadmapItem
                label=""
                description="Compra de dominio y creación de cuentas AWS y Stripe"
                position="left"
                leftPosition="32.2%"
              />
              <RoadmapItem
                label="Noviembre"
                description="Seleccionados para sistir al bootcamp de Heineken Green Challenge y seleccionados para programa de aceleración"
                position="right"
                leftPosition="65.6%"
              />
              <RoadmapItem
                label=""
                description="Primeras versiones del proyecto en línea"
                position="left"
                leftPosition="33.2%"
              />
              <RoadmapItem
                label="Diciembre"
                description="Presentación de negocio AMVI a XIGNUX e ITESM"
                position="right"
                leftPosition="66.2%"
              />
              <RoadmapItem
                label=""
                description="MVP listo"
                position="left"
                leftPosition="44%"
              />
              <span>2025</span>
              <RoadmapItem
                label="Enero"
                description="v0.8.2 - Implementación de mapas y conexión inicial de 'logs' para analíticos y retroalimentación"
                position="right"
                leftPosition="67.8%"
              />
              <RoadmapItem
                label=""
                description="v0.9.0 - Eliminaciones de datos: de cuentas empresariales, cuentas individuales, vehículos, grupos y rutinas"
                position="left"
                leftPosition="32.2%"
              />
              <RoadmapItem
                label="Marzo"
                description="v0.9.2 - Optimización de mapas, especialmente para crear viaje"
                position="right"
                leftPosition="67.8%"
              />
              <RoadmapItem
                label=""
                description="v0.9.3 - Crear viaje con selección de asiento y ruta dinámica; calificación de viaje"
                position="left"
                leftPosition="32.2%"
              />
              <RoadmapItem
                label=""
                description="v0.9.4 - Agregar contactos; conexión de tutoriales e historial de viajes"
                position="right"
                leftPosition="67.8%"
              />
              <RoadmapItem
                label="Abril"
                description="v0.9.5 - Landing Page con Hackathon CDMX y ROADMAP"
                position="left"
                leftPosition="32.2%"
              />
              <RoadmapItem
                label=""
                description="v0.9.6 - Tienda sin carrito; carga de documentos a AWS"
                position="right"
                leftPosition="67.8%"
              />
              <RoadmapItem
                label=""
                description="v0.9.7 - Preparación de apps para subir a Apple y Play Stores"
                position="left"
                leftPosition="32.2%"
              />
              <RoadmapItem
                label=""
                description="v0.9.8 - Funciones de asistencia y seguridad, configuraciones adicionales, cálculo CO2 por cada viaje
"
                position="right"
                leftPosition="67.8%"
              />
              <RoadmapItem
                label=""
                description="v0.9.9 - Mejoras visuales; retroalimentaciones en acciones; conexión de contactos"
                position="left"
                leftPosition="32.2%"
              />
              <RoadmapItem
                label="Mayo"
                description="v1.0.0 - Lanzamiento listo para aplicaciones móviles"
                position="right"
                leftPosition="67.8%"
              />
              <RoadmapItem
                label=""
                description="v1.0.1 - Ajustes en publicaciones; contactos funcionales"
                position="left"
                leftPosition="32.2%"
              />
              <RoadmapItem
                label=""
                description="v1.0.2 - Notificaciones"
                position="right"
                leftPosition="66.5%"
              />
              <RoadmapItem
                label=""
                description="v1.0.3 - Funciones continuas de la app: ; idiomas en app/web/backend; lógica de zona horaria;  modo oscuro; más 'logs' y tutoriales"
                position="left"
                leftPosition="34.2%"
              />
              <RoadmapItem
                label=""
                description="v1.0.4 - Historial de placas"
                position="right"
                leftPosition="60.7%"
              />
              <RoadmapItem
                label=""
                description="v1.0.5 - Inicio de grupos y estadísticas"
                position="left"
                leftPosition="34.2%"
              />
              <RoadmapItem
                label=""
                description="v1.0.6 - Continuación de grupos y estadísticas"
                position="right"
                leftPosition="67.8%"
              />
              <RoadmapItem
                label=""
                description="v1.1.0 - Tienda sin venta; nuevos botones de viaje; filtros"
                position="left"
                leftPosition="32.2%"
              />
              <RoadmapItem
                label=""
                description="v1.1.1 - Funcionalidad de favoritos y bloqueados"
                position="right"
                leftPosition="67.8%"
              />
              <RoadmapItem
                label="Junio"
                description="v1.1.3 - Mejora de buscadores"
                position="left"
                leftPosition="38%"
              />
              <RoadmapItem
                label=""
                description="v1.1.5 - Implementación de filtros"
                position="right"
                leftPosition="63.5%"
              />
              <RoadmapItem
                label=""
                description="v1.2.0 - Rutinas completamente funcionales"
                position="left"
                leftPosition="32.2%"
              />
              <RoadmapItem
                label=""
                description="v.1.2.5 - Facturacion disponible para empresas"
                position="right"
                leftPosition="67.8%"
              />
              <RoadmapItem
                label="Julio"
                description="v1.3.0 - Grupos completamente funcionales"
                position="left"
                leftPosition="32.2%"
              />
              <RoadmapItem
                label=""
                description="v1.4.0 - Tienda activa; ajustes para uso masivo"
                position="right"
                leftPosition="67.8%"
              />
              <div className="big-final-circle" />
              <div className="roadmap-footer" />
            </div>
          </div>
          <Footer inLandingPage={false} />
        </div>
      ) : (
        <HambMenu
          showMenu={showMenu}
          setShowMenu={setShowMenu}
          inLandingPage={false}
        />
      )}
    </>
  );
};

export { Roadmap };
